import React from 'react'

const SvgLeafOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.664 16.825A8 8 0 0113.046 4H18a3.044 3.044 0 013.045 3.045V12A8 8 0 018.06 18.257l-.88.87a5.904 5.904 0 01-4.154 1.712H3a1 1 0 110-2h.027a3.904 3.904 0 002.747-1.132l.89-.882zM18.61 12a5.563 5.563 0 01-8.799 4.526l1.595-1.576 3.581.05a1 1 0 10.028-2l-1.612-.022 2.8-2.766a1 1 0 10-1.405-1.424L12 11.551V10a1 1 0 10-2 0v3.527L8.419 15.09a5.563 5.563 0 014.627-8.653H18c.336 0 .608.272.608.608V12z'
    />
  </svg>
)

export default SvgLeafOutline
